"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campodolcino": {
    "81179fcc": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "acero": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campodolcino"
    }],
    "6a7c423d": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "corti": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campodolcino"
    }],
    "fcecca94": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pietra": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campodolcino"
    }],
    "a11f98c7": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "portarezza": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campodolcino"
    }],
    "af326b9b": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tini": [{
      "hkey": "20e2c625",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campodolcino"
    }]
  }
};
exports["default"] = _default;